import { Card, CardContent, CardHeader, Grid } from '@material-ui/core';
import React from 'react';

// styles
import useStyles from './styles';

// images
import logo from '../../images/logo-large.jpg';

// components
import { Typography } from '../../components/Wrappers';

const ContactUs = () => {
    const classes = useStyles();

    const PhoneAndEmailCard = () => (
        <Card className={classes.cardMedia}>
            <CardHeader title="Email Address & Phone Number" />
            <CardContent className={classes.cardContent}>
                <Typography
                    variant="h6"
                    color="textSecondary"
                    component="p"
                    style={{ fontWeight: 'bold', paddingBottom: 5 }}
                >
                    Head Office
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    <a href="tel:0735473970">0735 473 970</a>
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    From overseas: <a href="tel:+61735473970">+61 735 473 970</a>
                </Typography>

                <Typography
                    variant="h6"
                    color="textSecondary"
                    component="p"
                    style={{ fontWeight: 'bold', paddingBottom: 5, paddingTop: 20 }}
                >
                    Australia
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    Alan Cantero: <a href="tel:0423551145">0423 551 145</a>
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    Aurelien Coursodon: <a href="tel:0449955107">0449 955 107</a>
                </Typography>

                <Typography
                    variant="h6"
                    color="textSecondary"
                    component="p"
                    style={{ fontWeight: 'bold', paddingBottom: 5, paddingTop: 20 }}
                >
                    General Email Address
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    <a href="mailto:info@smile-academy.com.au">info@smile-academy.com.au</a>
                </Typography>
            </CardContent>
        </Card>
    );

    const PostalAddressCard = () => (
        <Card className={classes.cardMedia}>
            <CardHeader title="Postal Address" />
            <CardContent className={classes.cardContent}>
                <Typography variant="body1" color="textSecondary" component="p">
                    Delivery address for traditional impressions:
                </Typography>

                <Typography
                    variant="h6"
                    color="textSecondary"
                    component="p"
                    style={{ fontWeight: 'bold', paddingBottom: 5, paddingTop: 20 }}
                >
                    Smile Academy
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    PO Box 355
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    Lutwyche, 4030, QLD
                </Typography>
                <Typography variant="h6" color="textSecondary" component="p">
                    Australia
                </Typography>
                <img
                    src={logo}
                    width="300px"
                    alt="logo"
                    className={classes.logotypeImage}
                    style={{ marginLeft: '4rem', paddingTop: 20 }}
                />
            </CardContent>
        </Card>
    );

    return (
        <>
            <Grid container className={classes.gridRow}>
                <Grid item className={classes.gridItem}>
                    <PhoneAndEmailCard />
                </Grid>
                <Grid item className={classes.gridItem}>
                    <PostalAddressCard />
                </Grid>
            </Grid>
        </>
    );
};

export default ContactUs;
